import { AutogenLayoutPortalSqlDDef } from "./autogen/AutogenLayoutPortalSqlDDef";
import {  ClickEvent } from "@mcleod/components";

export class PortalSqlDDef extends AutogenLayoutPortalSqlDDef {
    private timer: any;

    override onLoad() {
        clearInterval(this.timer);
        this.timer = setInterval(() => this.setid(), 200);
    }

  async setid() {
    clearInterval(this.timer);
    this.timer = null;
    if( this.textboxLgxsdSqlseq.text == "" && this.sourceRenlgxsqld.mode == "add" )
    {
        await this.sourceRenlgxsqld2.search();
        const rows: any[] = this.sourceRenlgxsqld2.data;
        let maxid = 0;
        for (const row of rows) {
            const fid = row._data.lgxsd_sqlseq;
            if( fid > maxid )
                maxid = fid;
        }
        maxid++;
        this.textboxLgxsdSqlseq.text = maxid.toString();
    }
  }

  public setGidSequence( gid:any, seq:any ) {
    this.textboxLgxsdSqlgid.text = gid.toString();
    this.textboxLgxsdSqlseq.text = seq.toString();
  }

/** This is an event handler for the onChange event of chkbFormatSql. */
  chkbFormatSqlOnChange(event: ClickEvent)
  {
	let s: string = this.textboxLgxsdSqlstmt.text;
	if( this.chkbFormatSql.checked )
		s = this.formatSQL( s );
	else
		s = this.CleanDataValue( s );
	this.textboxLgxsdSqlstmt.text = s;
  }
  formatSQL(sql: string) : string
  {
	//Handles select case statement
	sql = this.replaceStr(sql, " WHEN ", "\n\t WHEN ");
	sql = this.replaceStr(sql, " THEN ", "\n\t\t THEN ");
	sql = this.replaceStr(sql, " ELSE ", "\n\t ELSE ");
	sql = this.replaceStr(sql, " END ", "\n\t END ");
	sql = this.replaceStr(sql, " when ", "\n\t when ");
	sql = this.replaceStr(sql, " then ", "\n\t\t then ");
	sql = this.replaceStr(sql, " else ", "\n\t else ");
	sql = this.replaceStr(sql, " end ", "\n\t end ");
    //Handles all others
	sql = this.replaceStr(sql, " FROM ", "\n FROM ");
	sql = this.replaceStr(sql, " WHERE ", "\n WHERE ");
	sql = this.replaceStr(sql, "," , ",\n\t");
	sql = this.replaceStr(sql, " AND ", " AND \n\t");
	sql = this.replaceStr(sql, " OR ", " OR \n\t");
	sql = this.replaceStr(sql, "LEFT JOIN", "\nLEFT JOIN");
	sql = this.replaceStr(sql, "ORDER BY", "\nORDER BY");
	sql = this.replaceStr(sql, " from ", "\n from ");
	sql = this.replaceStr(sql, " where ", "\n where ");
	sql = this.replaceStr(sql, " and ", " and \n\t");
	sql = this.replaceStr(sql, " or ", " or \n\t");
	sql = this.replaceStr(sql, "left join", "\nleft join");
	sql = this.replaceStr(sql, "order by", "\norder by");
	return( sql );
  }
  replaceStr(a:string, b:string, c:string) : string
  {
    const s: any = a;
    const r: any = s.replaceAll( b , c );
	return r;
  }
  CleanDataValue( val: string ) : string
  {
    let r: any = "";
    let i: number;
	for( i = 0; i < val.length; i++ )
	{
		if( val[i] >= ' ' && val[i] <= '}' )
			r += val[i];
	}
    return r;
  }

}
